<div class="pointer-events-none fixed right-4 bottom-4 z-[1000] flex flex-col-reverse gap-2">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="pointer-events-auto flex min-w-[300px] max-w-[420px] items-center gap-3 px-4 py-3 text-sm font-medium"
      [class]="toastClasses(toast.type)"
      role="status">
      <span class="flex-1">{{ toast.message }}</span>
      <button
        type="button"
        class="text-xs font-semibold tracking-wide uppercase cursor-pointer"
        [class]="dismissClasses(toast.type)"
        (click)="toastService.dismiss(toast.id)">
        Dismiss
      </button>
    </div>
  }
</div>
